export enum Namespace {
  DEFAULT = "DEFAULT",
  ANALYTICS = "ANALYTICS",
  ATLAS = "ATLAS",
  AUTHENTICATION = "AUTHENTICATION",
  DATA_COLLECTION = "DATA_COLLECTION",
  DOCUMENTS = "DOCUMENTS",
  EMISSIONS = "EMISSIONS",
  ERROR = "ERROR",
  HOME = "HOME",
  HUB = "HUB",
  INTEGRATION_HEALTH = "INTEGRATION_HEALTH",
  METHODOLOGIES = "METHODOLOGIES",
  COLLECTION_STATUS = "COLLECTION_STATUS",
  TRANSACTIONS = "TRANSACTIONS",
}

export enum Group {
  DEFAULT = "DEFAULT",
  ACTIVITY_DATA = "ACTIVITY_DATA",
  AUDIT = "AUDIT",
  BUSY_MESSAGES = "BUSY_MESSAGES",
  CALCULATION = "CALCULATION",
  CARDS = "CARDS",
  CONSOLIDATION = "CONSOLIDATION",
  DATA_COLLECTION = "DATA_COLLECTION",
  EMAIL = "EMAIL",
  EXPORT = "EXPORT",
  FILES = "FILES",
  FILTERS = "FILTERS",
  INTEGRATION = "INTEGRATION",
  LOGIN = "LOGIN",
  MODAL = "MODAL",
  OVERVIEW = "OVERVIEW",
  SCOPE_2 = "SCOPE_2",
  SCOPE_3 = "SCOPE_3",
  SETTINGS = "SETTINGS",
  SUBMISSION = "SUBMISSION",
  SUBMISSION_GROUP = "SUBMISSION_GROUP",
  SUBMISSION_GROUP_UPLOAD = "SUBMISSION_GROUP_UPLOAD",
  SUBMISSION_SLOTS = "SUBMISSION_SLOTS",
  SUBMISSION_SLOT_DETAILS = "SUBMISSION_SLOT_DETAILS",
  SUBMIT_MODAL = "SUBMIT_MODAL",
  SUMMARY = "SUMMARY",
  SUPPLIER_INVITATION = "SUPPLIER_INVITATION",
  TABS = "TABS",
  TASKS = "TASKS",
  TASK_DETAILS = "TASK_DETAILS",
  TEMPLATES = "TEMPLATES",
  UPLOAD = "UPLOAD",
  UPDATE = "UPDATE",
  VARIANCE_CHECKS = "VARIANCE_CHECKS",
}
